<div class="modal-header">
  <h5 class="modal-title">Beneficiario</h5>
  <div class="ms-auto me-3 text-end">
    <div class="small"><strong>Sociedad:</strong> {{sociedadNombre || sociedadRfc}}<span *ngIf="sociedadNombre && sociedadRfc" class="text-muted"> ({{sociedadRfc}})</span></div>
    <div class="small"><strong>Accionista:</strong> {{shareholderNombre || shareholderUsuarioRfc}}<span *ngIf="shareholderNombre && shareholderUsuarioRfc" class="text-muted"> ({{shareholderUsuarioRfc}})</span></div>
  </div>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div *ngIf="lastSaveError" class="alert alert-danger alert-dismissible fade show" role="alert">
    <strong>Error al guardar:</strong> {{ lastSaveError }}
    <p class="mb-0 mt-2 small">Los datos se mantienen en el formulario. Puede corregir la información y volver a intentar, o tomar una captura de pantalla para enviar a soporte.</p>
    <button type="button" class="btn-close" aria-label="Cerrar" (click)="lastSaveError = null"></button>
  </div>
  <form [formGroup]="personForm">

    <!-- Basic Fields -->
    <div class="mb-3">
      <label>Nombre Completo</label>
      <input type="text" class="form-control" formControlName="full_name"
             [class.input-validation-error]="personForm.get('full_name')?.invalid && personForm.get('full_name')?.touched"
             [class.input-validation-valid]="personForm.get('full_name')?.valid && personForm.get('full_name')?.value">
      <small class="text-danger" *ngIf="personForm.get('full_name')?.invalid && personForm.get('full_name')?.touched">
        El nombre debe tener al menos 4 caracteres.
      </small>
    </div>

    <div class="mb-3">
      <label>Alias</label>
      <input type="text" class="form-control" formControlName="alias"
             [class.input-validation-error]="personForm.get('alias')?.invalid && personForm.get('alias')?.touched"
             [class.input-validation-valid]="personForm.get('alias')?.valid && personForm.get('alias')?.value">
      <small class="text-danger" *ngIf="personForm.get('alias')?.invalid && personForm.get('alias')?.touched">
        El alias debe tener al menos 4 caracteres.
      </small>
    </div>

    <!-- Emails -->
    <div formArrayName="emails" class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="mb-0">Emails</label>
        <button type="button" class="btn btn-sm btn-primary" (click)="addEmail()">+</button>
      </div>
      <small class="text-danger d-block" *ngIf="personForm.get('emails')?.invalid && personForm.get('emails')?.errors?.['atLeastOneEmail']">
        Debe agregar al menos un correo electrónico válido con su tipo.
      </small>
      <div *ngFor="let email of emails.controls; let i = index" [formGroupName]="i" class="border p-2 mb-2 rounded">
        <div class="mb-1">
          <input type="email" class="form-control" formControlName="email" placeholder="Correo electrónico"
                 [class.input-validation-error]="emails.at(i).get('email')?.invalid && emails.at(i).get('email')?.touched"
                 [class.input-validation-valid]="emails.at(i).get('email')?.valid && emails.at(i).get('email')?.value">
          <small class="text-danger" *ngIf="emails.at(i).get('email')?.invalid && emails.at(i).get('email')?.touched">
            Ingrese un correo electrónico válido.
          </small>
        </div>
        <div formGroupName="email_type" class="mt-1">
          <select class="form-select"
                  formControlName="name"
                  [class.input-validation-error]="emails.at(i).get('email_type.name')?.invalid && emails.at(i).get('email_type.name')?.touched"
                  [class.input-validation-valid]="emails.at(i).get('email_type.name')?.valid && emails.at(i).get('email_type.name')?.value">
            <option value="">Seleccione tipo...</option>
            <option *ngFor="let type of EMAIL_TYPES" [value]="type">{{ type }}</option>
          </select>
          <small class="text-danger" *ngIf="emails.at(i).get('email_type.name')?.invalid && emails.at(i).get('email_type.name')?.touched">
            Seleccione un tipo de correo.
          </small>
        </div>
        <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeEmail(i)">Eliminar</button>
      </div>
    </div>

    <!-- Phones -->
    <div formArrayName="phones" class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="mb-0">Teléfonos</label>
        <button type="button" class="btn btn-sm btn-primary" (click)="addPhone()">+</button>
      </div>
      <small class="text-danger d-block" *ngIf="personForm.get('phones')?.invalid && personForm.get('phones')?.errors?.['atLeastOnePhone']">
        Debe agregar al menos un teléfono válido con su tipo.
      </small>
      <div *ngFor="let phone of phones.controls; let i = index" [formGroupName]="i" class="border p-2 mb-2 rounded">
        <div class="mb-1">
          <input type="text" class="form-control" formControlName="phone_number" placeholder="Número de teléfono"
                 [class.input-validation-error]="phones.at(i).get('phone_number')?.invalid && phones.at(i).get('phone_number')?.touched"
                 [class.input-validation-valid]="phones.at(i).get('phone_number')?.valid && phones.at(i).get('phone_number')?.value">
          <small class="text-danger" *ngIf="phones.at(i).get('phone_number')?.invalid && phones.at(i).get('phone_number')?.touched">
            Ingrese un número de teléfono válido (mín. 8 dígitos).
          </small>
        </div>
        <div formGroupName="phone_type" class="mt-1">
          <select class="form-select"
                  formControlName="name"
                  [class.input-validation-error]="phones.at(i).get('phone_type.name')?.invalid && phones.at(i).get('phone_type.name')?.touched"
                  [class.input-validation-valid]="phones.at(i).get('phone_type.name')?.valid && phones.at(i).get('phone_type.name')?.value">
            <option value="">Seleccione tipo...</option>
            <option *ngFor="let type of PHONE_TYPES" [value]="type">{{ type }}</option>
          </select>
          <small class="text-danger" *ngIf="phones.at(i).get('phone_type.name')?.invalid && phones.at(i).get('phone_type.name')?.touched">
            Seleccione un tipo de teléfono.
          </small>
        </div>
        <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removePhone(i)">Eliminar</button>
      </div>
    </div>

    <!-- Relatives (optional) -->
    <div formArrayName="relatives" class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="mb-0">Personas políticamente expuestas <span class="text-muted fw-normal">(opcional)</span></label>
        <button type="button" class="btn btn-sm btn-primary" (click)="addRelative()">+</button>
      </div>
      <small class="text-muted d-block mb-2">Puede dejar esta sección vacía o agregar uno o más registros.</small>
      <div *ngFor="let relative of relatives.controls; let i = index" [formGroupName]="i" class="border p-2 mb-2 rounded">
        <div class="mb-1">
          <input type="text" class="form-control" formControlName="name" placeholder="Nombre Completo"
                 [class.input-validation-error]="relatives.at(i).get('name')?.invalid && relatives.at(i).get('name')?.touched"
                 [class.input-validation-valid]="relatives.at(i).get('name')?.valid && relatives.at(i).get('name')?.value">
          <small class="text-danger" *ngIf="relatives.at(i).get('name')?.invalid && relatives.at(i).get('name')?.touched">
            El nombre debe tener al menos 4 caracteres.
          </small>
        </div>
        <div formGroupName="relative_type" class="mt-1">
          <select class="form-select"
                  formControlName="name"
                  [class.input-validation-error]="relatives.at(i).get('relative_type.name')?.invalid && relatives.at(i).get('relative_type.name')?.touched"
                  [class.input-validation-valid]="relatives.at(i).get('relative_type.name')?.valid && relatives.at(i).get('relative_type.name')?.value">
            <option value="">Seleccione tipo...</option>
            <option *ngFor="let type of RELATIVE_TYPES" [value]="type">{{ type }}</option>
          </select>
          <small class="text-danger" *ngIf="relatives.at(i).get('relative_type.name')?.invalid && relatives.at(i).get('relative_type.name')?.touched">
            Seleccione un tipo de familiar.
          </small>
        </div>

        <!-- Address -->
        <div formGroupName="address" class="mt-2">
          <input type="text" class="form-control mb-1" formControlName="street" placeholder="Calle">
          <input type="text" class="form-control mb-1" formControlName="house_number" placeholder="# Exterior">
          <input type="text" class="form-control mb-1" formControlName="zip_code" placeholder="C.P">
          <input type="text" class="form-control mb-1" formControlName="country" placeholder="País">
        </div>

        <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeRelative(i)">Eliminar</button>
      </div>
    </div>

    <!-- Identities -->
    <div formArrayName="identitys" class="mb-3">
      <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="mb-0">Identificaciones</label>
        <button type="button" class="btn btn-sm btn-primary" (click)="addIdentity()">+</button>
      </div>
      <div *ngFor="let iden of identitys.controls; let i = index" [formGroupName]="i" class="border p-2 mb-2 rounded">
        <input type="text" class="form-control mb-1" formControlName="id_number" placeholder="Número de identificación">
        <div formGroupName="identity_type" class="input-group mt-1">
          <input type="text" class="form-control" formControlName="name" placeholder="Tipo de identificación (Pasaporte, Licencia)">
        </div>
        <input type="text" class="form-control mt-1" formControlName="authority" placeholder="Autoridad emisora">
        <input type="text" class="form-control mt-1" formControlName="couuntry" placeholder="País">

        <div class="mt-2">
          <label class="form-label small mb-1">Documento (PDF, JPEG o PNG, máx. 2 MB)</label>
          <div class="input-group">
            <input type="file" class="form-control form-control-sm" [id]="'identity-file-' + i"
                   accept=".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png"
                   (change)="onIdentityFileSelected($event, i)">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="clearIdentityFile(i)" *ngIf="getIdentityFileName(i)"
                    title="Quitar archivo">✕</button>
          </div>
          <small class="text-success" *ngIf="getIdentityFileName(i) && !identityFileErrors[i]">{{ getIdentityFileName(i) }}</small>
          <small class="text-danger" *ngIf="identityFileErrors[i]">{{ identityFileErrors[i] }}</small>
        </div>

        <button type="button" class="btn btn-sm btn-danger mt-2" (click)="removeIdentity(i)">Eliminar</button>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss()">Cancelar</button>
  <button type="button" class="btn btn-success" (click)="save()" [disabled]="personForm.invalid">Guardar</button>
</div>
